import { ContractRevenueItem } from "@/pages/contracts/types";
import { DraftRevenueItem } from "@/pages/contracts/components/termsDraft/types";

// Absent and unparseable are different answers: absent means open-ended, while an
// unparseable date says nothing about when the period ends.
const OPEN_ENDED = "open-ended";
const UNREADABLE = "unreadable";

const asTime = (
  date: string | null | undefined
): number | typeof OPEN_ENDED | typeof UNREADABLE => {
  if (!date) return OPEN_ENDED;
  const time = new Date(date).getTime();
  return Number.isNaN(time) ? UNREADABLE : time;
};

// True when a pending line now ends earlier than the terms it came from; a bad date fails closed.
export const hasShortenedServicePeriod = (
  items: DraftRevenueItem[],
  baseline: Record<string, ContractRevenueItem>
): boolean =>
  items.some((item) => {
    if (item.draftDeleted) return false;
    const original = baseline[item.id];
    if (!original) return false;

    const originalEnd = asTime(original.serviceEndDate);
    const pendingEnd = asTime(item.serviceEndDate);
    if (originalEnd === UNREADABLE || pendingEnd === UNREADABLE) return false;
    // An open-ended line given any end date stops a service that had no end.
    if (originalEnd === OPEN_ENDED) return pendingEnd !== OPEN_ENDED;
    if (pendingEnd === OPEN_ENDED) return false;
    return pendingEnd < originalEnd;
  });
